import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { RestaurantServiceService } from '../../restaurant/restaurant-service.service';
@Component({
  selector: 'app-update-addon',
  templateUrl: './update-addon.component.html',
  styleUrls: ['./update-addon.component.scss']
})
export class UpdateAddonComponent implements OnInit {
  id: number;
  Id;
  alert = false;
  addonDetail: any = {};
  restId: number;
  menuId;
  page: number;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private restaurantServices: RestaurantServiceService,
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.Id = this.route.snapshot.params['Id'];
    this.restId = this.route.snapshot.params['restId'];
    this.menuId = this.route.snapshot.params['menuId'];
    this.editAddon();
  }
  editAddon() {

    this.restaurantServices.getAddonId(this.id).subscribe(Response => {
    this.addonDetail = Response;
    console.log('it is updation', this.addonDetail);
    });
  }
  onSubmit() {

    console.log(this.addonDetail);
    this.restaurantServices.UpdateAddon(this.addonDetail).subscribe((Data: any) => {
      this.toastr.success('Ingre updated...');
      this.router.navigateByUrl('/mealDetail/' + this.restId + '/' + this.menuId + '/' + this.Id );
    console.log('database updated', Data);
    });
}

}
